/**
 * Módulos Angular
 */

import { APP_INITIALIZER, NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData, DatePipe } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import localeEsArExtra from '@angular/common/locales/extra/es-AR';

/**
 * Módulos terceros
 */

import { JwtModule } from '@auth0/angular-jwt';
import { MaterialModule } from './shared/material/material.module';
import { MessageService } from 'primeng-lts/api';
import { NgxSpinnerModule } from "ngx-spinner";
import { PrimeNGModule } from './shared/primeng/primeng.module';
import { RoutingModule } from './shared/routing/routing.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

/**
 * Servicios Propios
 */

import { AdmService } from './shared/services/adm.service';
import { AppErrorHandler } from './shared/services/error.service';
import { AuthGuard } from './shared/utils/auth.guard';
import { ConfigService } from './shared/services/config.service';
import { CuentasService } from './shared/services/cuentas.service';
import { ExcelService } from './shared/services/excel.service';
import { getToken, LoggedService } from './shared/services/logged.service';
import { LoggedGuard } from './shared/utils/logged.guard';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorIntlCro } from './shared/material/materialPaginatorTranslation';
import { NCService } from './shared/services/nc.service';
import { NumberDirective } from './shared/directives/numbers-only.directive';
import { PEPService } from './shared/services/pep.service';
import { PVService } from './shared/services/pv.service';
import { ReplaceDate } from './shared/utils/date.pipe';
import { ReplaceDecimal } from './shared/utils/decimal.pipe';
import { ReportesService } from './shared/services/reportes.service';
import { SidenavService } from './shared/services/sidenav.service';
import { SnackbarService } from './shared/services/snackbar.service';
import { SpinnerngxService } from './shared/spinnerngx/spinnerngx.service';
import { TablasService } from './shared/services/tablas.service';
import { ThreeDigitDecimaNumberDirective } from './shared/directives/three-digit-decima-number.directive';
import { ThreeDigitDecimalNumberComaDirective } from './shared/directives/three-digit-decimal-number-coma.directive';
import { TooltipListPipe } from './shared/utils/tooltip-list.pipe';
import { TwoDigitDecimaNumberDirective } from './shared/directives/two-digit-decima-number.directive';
import { UsuariosService } from './shared/services/usuarios.service';
import { CotizacionesService } from './shared/services/cotizaciones.service';
import { PAService } from './shared/services/pa.service';
import { TPService } from './shared/services/tp.service';
import { TDService } from './shared/services/td.service';
/**
 * Componentes Propios
 */


import { AppComponent } from './app.component';
import { AutorizacionesDtoDiscComponent } from './tablas/autorizaciones-dto-disc/autorizaciones-dto-disc.component';
import { AutorizacionesDtoDiscDialogComponent } from './tablas/autorizaciones-dto-disc/autorizaciones-dto-disc-dialog.component';
import { AutorizacionesNCComponent } from './tablas/autorizaciones-nc/components/autorizaciones-nc.component';
import { AutorizacionesNCDialogComponent } from './tablas/autorizaciones-nc/components/autorizaciones-nc-dialog.component';
import { CambioClaveComponent } from './user-Management/components/cambioclave.component';
import { CampaniasComponent } from './tablas/campanias/campanias.component';
import { CampaniasDialogComponent } from './tablas/campanias/campanias-dialog.component';
import { ComentarioPedidoDialogComponent } from './shared/components/comentario-pedido-dialog/comentario-pedido-dialog.component';
import { NroOCDialogComponent } from './shared/components/nrooc-dialog/nrooc-dialog.component';
import { ConfirmacionDialogComponent } from './shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { ConfirmarEmailComponent } from './user-Management/components/confirmar-email.component';
import { CotizacionAprobacionRetenidaDialogComponent } from './pedidos/cotizaciones/components/cotizacion-aprobacion-retenida-dialog.component';
import { CotizacionComponent } from './pedidos/cotizaciones/components/cotizacion.component';
import { CotizacionesBuscadorComponent } from './pedidos/cotizaciones/components/cotizaciones-buscador.component';
import { CotizacionItemDialogComponent } from './pedidos/cotizaciones/components/cotizacion-item-dialog.component';
import { CotizacionLogsDialogComponent } from './pedidos/cotizaciones/components/cotizacion-logs-dialog.component';
import { CotizacionRetencionesDialogComponent } from './pedidos/cotizaciones/components/cotizacion-retenciones-dialog.component';
import { CuentasComponent } from './cuentas/cuentas/components/cuentas.component';
import { CuentasDialogComponent } from './cuentas/cuentas/components/cuentas-dialog.component';
import { CuotasDistribuidoresComponent } from './productos/cuotas-distribuidores/cuotas-distribuidores.component';
import { CuotasDistribuidoresDialogComponent } from './productos/cuotas-distribuidores/cuotas-distribuidores-dialog.component';
import { CuotasPlantasComponent } from './productos/cuotas-plantas/cuotas-plantas.component';
import { CuotasPlantasDialogComponent } from './productos/cuotas-plantas/cuotas-plantas-dialog.component';
import { DepositosComponent } from './tablas/depositos/depositos.component';
import { DepositosDialogComponent } from './tablas/depositos/depositos-dialog.component';
import { DistribuidoresComponent } from './tablas/distribuidores/distribuidores.component';
import { DistribuidoresDialogComponent } from './tablas/distribuidores/distribuidores-dialog.component';
import { DivisionesComponent } from './tablas/divisiones/divisiones.component';
import { DivisionesDialogComponent } from './tablas/divisiones/divisiones-dialog.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { FooternotloginComponent } from './shared/components/footernotlogin/footernotlogin.component';
import { GruposClientesComponent } from './tablas/grupos-clientes/components/grupos-clientes.component';
import { GruposClientesDialogComponent } from './tablas/grupos-clientes/components/grupos-clientes-dialog.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { HeadernotloginComponent } from './shared/components/headernotlogin/headernotlogin.component';
import { HomeComponent } from './home/components/home.component';
import { InventariosComponent } from './productos/inventarios/components/inventarios.component';
import { ItemsParametrosComponent } from './adm/parametros/components/items-parametros.component';
import { ItemsParametrosDialogComponent } from './adm/parametros/components/items-parametros-dialog.component';
import { ListasPreciosCabecerasDialogComponent } from './productos/listas-precios/components/listas-precios-cabeceras-dialog.component';
import { ListasPreciosComponent } from './productos/listas-precios/components/listas-precios.component';
import { ListasPreciosItemsDialogComponent } from './productos/listas-precios/components/listas-precios-items-dialog.component';
import { LoginComponent } from './user-Management/components/login.component';
import { MotivosDevolucionNCComponent } from './tablas/motivos-devolucion-nc/motivos-devolucion-nc.component';
import { MotivosDevolucionNCDialogComponent } from './tablas/motivos-devolucion-nc/motivos-devolucion-nc-dialog.component';
import { NcBuscadorComponent } from './pedidos/notas-credito/components/nc-buscador.component';
import { NcComponent } from './pedidos/notas-credito/components/nc.component';
import { NCFacturasDialogComponent } from './pedidos/notas-credito/components/nc-facturas-dialog.component';
import { NCItemDialogComponent } from './pedidos/notas-credito/components/nc-item-dialog.component';
import { NCLogsDialogComponent } from './pedidos/notas-credito/components/nc-logs-dialog.component';
import { NCPedidosRelacionadosDialogComponent } from './pedidos/notas-credito/components/nc-pedidos-relacionados-dialog.component';
import { NCRemitosDialogComponent } from './pedidos/notas-credito/components/nc-remitos-dialog.component';
import { NumeradoresComponent } from './tablas/numeradores/numeradores.component';
import { NumeradoresDialogComponent } from './tablas/numeradores/numeradores-dialog.component';
import { PageNotFoundComponent } from './page-not-found/components/page-not-found.component';
import { ParametrosComponent } from './adm/parametros/components/parametros.component';
import { ParametrosDialogComponent } from './adm/parametros/components/parametros-dialog.component';
import { PEPAprobacionRetenidoDialogComponent } from './pedidos/pedidos-especiales-planta/components/pep-aprobacion-retenido-dialog.component';
import { PEPBuscadorComponent } from './pedidos/pedidos-especiales-planta/components/pep-buscador.component';
import { PEPComponent } from './pedidos/pedidos-especiales-planta/components/pep.component';
import { PEPItemDialogComponent } from './pedidos/pedidos-especiales-planta/components/pep-item-dialog.component';
import { PEPLogsDialogComponent } from './pedidos/pedidos-especiales-planta/components/pep-logs-dialog.component';
import { PEPRetencionesDialogComponent } from './pedidos/pedidos-especiales-planta/components/pep-retenciones-dialog.component';
import { ProcesosComponent } from './tablas/procesos/components/procesos.component';
import { ProductosComponent } from './productos/productos/components/productos.component';
import { ProductosDialogComponent } from './productos/productos/components/productos-dialog.component';
import { PVAprobacionRetenidoDialogComponent } from './pedidos/pedidos-ventas/components/pv-aprobacion-retenido-dialog.component';
import { PVBuscadorComponent } from './pedidos/pedidos-ventas/components/pv-buscador.component';
import { PVComponent } from './pedidos/pedidos-ventas/components/pv.component';
import { PVItemDialogComponent } from './pedidos/pedidos-ventas/components/pv-item-dialog.component';
import { PVLogsDialogComponent } from './pedidos/pedidos-ventas/components/pv-logs-dialog.component';
import { PVRetencionesDialogComponent } from './pedidos/pedidos-ventas/components/pv-retenciones-dialog.component';
import { RegionesComponent } from './tablas/regiones/regiones.component';
import { RegionesDialogComponent } from './tablas/regiones/regiones-dialog.component';
import { SelectorDivisionesComponent } from './shared/components/selector-divisiones/selector-divisiones.component';
import { SelectorEstadoPedidosComponent } from './shared/components/selector-estado-pedidos/selector-estado-pedidos.component';
import { SelectorPaisComponent } from './shared/components/selector-pais/selector-pais.component';
import { SelectorRegionesComponent } from './shared/components/selector-regiones/selector-regiones.component';
import { SelectorTiposOrdenesComponent } from './shared/components/selector-tipos-ordenes/selector-tipos-ordenes.component';
import { SnackbarComponent } from './shared/components/snackbar/snackbar.component';
import { StockPedidosDialogComponent } from './shared/components/stock-pedidos-dialog/stock-pedidos-dialog.component';
import { TerminosPagoComponent } from './tablas/terminos-pago/components/terminos-pago.component';
import { TerminosPagoDialogComponent } from './tablas/terminos-pago/components/terminos-pago-dialog.component';
import { TiposCambioComponent } from './tablas/tipos-cambio/tipos-cambio.component';
import { TiposCambioDialogComponent } from './tablas/tipos-cambio/tipos-cambio-dialog.component';
import { TiposListasPreciosComponent } from './tablas/tipos-listas-precios/components/tipos-listas-precios.component';
import { TiposListasPreciosDialogComponent } from './tablas/tipos-listas-precios/components/tipos-listas-precios-dialog.component';
import { TiposLPPorGrupoClienteComponent } from './tablas/tipos-lp-grupo-cliente/tipos-lp-por-grupo-cliente.component';
import { TiposLPPorGrupoClienteDialogComponent } from './tablas/tipos-lp-grupo-cliente/tipos-lp-por-grupo-cliente-dialog.component';
import { TiposLPPorTerminoPagoComponent } from './tablas/tipos-lp-termino-pago/tipos-lp-por-termino-pago.component';
import { TiposLPPorTerminoPagoDialogComponent } from './tablas/tipos-lp-termino-pago/tipos-lp-por-termino-pago-dialog.component';
import { UbicacionesAlmacenamientosComponent } from './tablas/ubicaciones-almacenamientos/ubicaciones-almacenamientos.component';
import { UbicacionesAlmacenamientosDialogComponent } from './tablas/ubicaciones-almacenamientos/ubicaciones-almacenamientos-dialog.component';
import { UsuariosComponent } from './adm/usuarios/components/usuarios.component';
import { UsuariosDialogComponent } from './adm/usuarios/components/usuarios-dialog.component';
import { VerificarCuentaComponent } from './user-Management/components/verificar-cuenta.component';
import { ZonasVendedoresComponent } from './tablas/zonas-vendedores/zonas-vendedores.component';
import { ZonasVendedoresDialogComponent } from './tablas/zonas-vendedores/zonas-vendedores-dialog.component';

import { PEPAComponent } from './pedidos/pedidos-especiales-planta-anticipada/component/pepa.component';
import { PEPABuscadorComponent } from './pedidos/pedidos-especiales-planta-anticipada/component/pepa-buscador.component';
import { PEPAItemDialogComponent } from './pedidos/pedidos-especiales-planta-anticipada/component/pepa-item-dialog.component';
import { PEPAAprobacionRetenidoDialogComponent } from './pedidos/pedidos-especiales-planta-anticipada/component/pepa-aprobacion-retenido-dialog.component';
import { PEPARetencionesDialogComponent } from './pedidos/pedidos-especiales-planta-anticipada/component/pepa-retenciones-dialog.component';
import { PEPALogsDialogComponent } from './pedidos/pedidos-especiales-planta-anticipada/component/pepa-logs-dialog.component';
import { PVAComponent } from './pedidos/pedidos-ventas-anticipada/components/pva.component';
import { PVAAprobacionRetenidoDialogComponent } from './pedidos/pedidos-ventas-anticipada/components/pva-aprobacion-retenido-dialog.component';
import { PVABuscadorComponent } from './pedidos/pedidos-ventas-anticipada/components/pva-buscador.component';
import { PVAItemDialogComponent } from './pedidos/pedidos-ventas-anticipada/components/pva-item-dialog.component';
import { PVALogsDialogComponent } from './pedidos/pedidos-ventas-anticipada/components/pva-logs-dialog.component';
import { PVARetencionesDialogComponent } from './pedidos/pedidos-ventas-anticipada/components/pva-retenciones-dialog.component';
import { ConfirmacionCotizacionComponent } from './confirmacion-cotizacion/confirmacion-cotizacion.component';
import { PAComponent } from './pedidos/pedidos-abastecimiento/components/pa.component';
import { PABuscadorComponent } from './pedidos/pedidos-abastecimiento/components/pa-buscador.component';
import { PALogsDialogComponent } from './pedidos/pedidos-abastecimiento/components/pa-logs-dialog.component';
import { PAItemDialogComponent } from './pedidos/pedidos-abastecimiento/components/pa-item-dialog.component';

import { AuthInterceptor } from './shared/utils/auth.interceptor';
import { ReportesPedidosBuscadorComponent } from './reportes/reportes-pedidos/components/reportes-pedidos-buscador.component';
import { ReportesPedidosDetalladosBuscadorComponent } from './reportes/reportes-pedidos-detallados/components/reportes-pedidos-detallados-buscador.component';
import { TPBuscadorComponent } from './pedidos/transferencias-planta/components/tp-buscador.component';
import { TPComponent } from './pedidos/transferencias-planta/components/tp.component';
import { TPItemDialogComponent } from './pedidos/transferencias-planta/components/tp-item-dialog.component';
import { TPLogsDialogComponent } from './pedidos/transferencias-planta/components/tp-logs-dialog.component';
import { TDComponent } from './pedidos/tranferencias-distribuidores/components/td.component';
import { TDBuscadorComponent } from './pedidos/tranferencias-distribuidores/components/td-buscador.component';
import { TDItemDialogComponent } from './pedidos/tranferencias-distribuidores/components/td-item-dialog.component';
import { TDLogsDialogComponent } from './pedidos/tranferencias-distribuidores/components/td-logs-dialog.component'; 
import { CuentasDistribuidoresDialogComponent } from './cuentas/cuentas/components/cuentas-distribuidores-dialog.component';
import { DireccionesDialogComponent } from './cuentas/cuentas/components/direcciones-dialog.component';
import { ShipToDistribuidoresDialogComponent } from './tablas/shipto-distribuidores/shipto-distribuidores-dialog.component';
import { ShipToDistribuidoresComponent } from './tablas/shipto-distribuidores/shipto-distribuidores.component';

registerLocaleData(localeEsAr, localeEsArExtra)
export function initializeApp(config: ConfigService) {
  return () => config.readData()
}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    AutorizacionesDtoDiscComponent,
    AutorizacionesDtoDiscDialogComponent,
    AutorizacionesNCComponent,
    AutorizacionesNCDialogComponent,
    CambioClaveComponent,
    CampaniasComponent,
    CampaniasDialogComponent,
    ComentarioPedidoDialogComponent,
    NroOCDialogComponent,
    ConfirmacionDialogComponent,
    ConfirmarEmailComponent,
    CuentasComponent,
    CuentasDialogComponent,
    DepositosComponent,
    DepositosDialogComponent,
    DistribuidoresComponent,
    DistribuidoresDialogComponent,
    DivisionesComponent,
    DivisionesDialogComponent,
    FooterComponent,
    FooternotloginComponent,
    GruposClientesComponent,
    GruposClientesDialogComponent,
    HeaderComponent,
    HeadernotloginComponent,
    HomeComponent,
    InventariosComponent,
    ItemsParametrosComponent,
    ItemsParametrosDialogComponent,
    ListasPreciosCabecerasDialogComponent,
    ListasPreciosComponent,
    ListasPreciosItemsDialogComponent,
    LoginComponent,
    NcBuscadorComponent,
    NcComponent,
    NCFacturasDialogComponent,
    NCItemDialogComponent,
    NCLogsDialogComponent,
    NCPedidosRelacionadosDialogComponent,
    NCRemitosDialogComponent,
    NumberDirective,
    NumeradoresComponent,
    NumeradoresDialogComponent,
    PageNotFoundComponent,
    ParametrosComponent,
    ParametrosDialogComponent,
    PEPAprobacionRetenidoDialogComponent,
    PEPBuscadorComponent,
    PEPComponent,
    PEPItemDialogComponent,
    PEPLogsDialogComponent,
    PEPRetencionesDialogComponent,
    ProcesosComponent,
    ProductosComponent,
    ProductosDialogComponent,
    PVAprobacionRetenidoDialogComponent,
    PVBuscadorComponent,
    PVComponent,
    PVItemDialogComponent,
    PVLogsDialogComponent,
    PVRetencionesDialogComponent,
    RegionesComponent,
    RegionesDialogComponent,
    ReplaceDate,
    ReplaceDecimal,
    SelectorDivisionesComponent,
    SelectorEstadoPedidosComponent,
    SelectorPaisComponent,
    SelectorRegionesComponent,
    SelectorTiposOrdenesComponent,
    SnackbarComponent,
    StockPedidosDialogComponent,
    TerminosPagoComponent,
    TerminosPagoComponent,
    TerminosPagoDialogComponent,
    TerminosPagoDialogComponent,
    ThreeDigitDecimaNumberDirective,
    ThreeDigitDecimalNumberComaDirective,
    TiposCambioComponent,
    TiposCambioDialogComponent,
    TiposListasPreciosComponent,
    TiposListasPreciosDialogComponent,
    TiposLPPorGrupoClienteComponent,
    TiposLPPorGrupoClienteDialogComponent,
    TiposLPPorTerminoPagoComponent,
    TiposLPPorTerminoPagoDialogComponent,
    TooltipListPipe,
    TwoDigitDecimaNumberDirective,
    UbicacionesAlmacenamientosComponent,
    UbicacionesAlmacenamientosDialogComponent,
    UsuariosComponent,
    UsuariosDialogComponent,
    VerificarCuentaComponent,
    ZonasVendedoresComponent,
    ZonasVendedoresDialogComponent,
    MotivosDevolucionNCComponent,
    MotivosDevolucionNCDialogComponent,
    CotizacionesBuscadorComponent,
    CotizacionComponent,
    CuotasPlantasComponent,
    CuotasPlantasDialogComponent,
    CuotasDistribuidoresComponent,
    CuotasDistribuidoresDialogComponent,
    CotizacionItemDialogComponent,
    CotizacionRetencionesDialogComponent,
    CotizacionLogsDialogComponent,
    PEPAComponent,
    CotizacionAprobacionRetenidaDialogComponent,
    PEPABuscadorComponent,
    PEPAItemDialogComponent,
    PEPAAprobacionRetenidoDialogComponent,
    PEPARetencionesDialogComponent,
    PEPALogsDialogComponent,
    PVAComponent,
    PVAAprobacionRetenidoDialogComponent,
    PVABuscadorComponent,
    PVAItemDialogComponent,
    PVALogsDialogComponent,
    PVARetencionesDialogComponent,
    ConfirmacionCotizacionComponent,
    PAComponent,
    PABuscadorComponent,
    PALogsDialogComponent,
    PAItemDialogComponent,
    ReportesPedidosBuscadorComponent,
    ReportesPedidosDetalladosBuscadorComponent,
    TPBuscadorComponent,
    TPComponent,
    TPItemDialogComponent,
    TPLogsDialogComponent,
    TPComponent,
    TPBuscadorComponent,
    TDComponent,
    TDBuscadorComponent,
    TDItemDialogComponent,
    TDLogsDialogComponent,
    CuentasDistribuidoresDialogComponent,
    DireccionesDialogComponent,
    ShipToDistribuidoresComponent,
    ShipToDistribuidoresDialogComponent,

  ],
  imports: [
    BrowserModule.withServerTransition({
      appId: 'PortalCS',
    }),
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    NgxSpinnerModule,
    PrimeNGModule,
    ReactiveFormsModule,
    RoutingModule,
    MatRadioModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: getToken,
        allowedDomains: ['https://api.dev-order2go.bayer.com','localhost:5001']
        //allowedDomains: ['https://o2g-dev-api.fargate-order2go.637423228349.cloud.bayer.com']
      }
    })
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // entryComponents: [
  //   CambioClaveComponent,
  //   ComprobantesComponent,
  //   ComprobantesDialogComponent,
  //   ConfirmarEmailComponent,
  //   CuentaCorrienteComponent,
  //   DetalleProductoDialogComponent,
  //   HomeComponent,
  //   PagenotfoundComponent,
  //   SnackbarComponent,
  //   TrackingProductoDataComponent,
  //   TrackingProductoWelcomeComponent,
  //   UsuariosDialogComponent,
  //   WelcomeComponent
  // ],
  providers: [

    AdmService,
    AuthGuard,
    ConfigService,
    CuentasService,
    DatePipe,
    ExcelService,
    LoggedGuard,
    LoggedService,
    MessageService,
    NCService,
    PEPService,
    PVService,
    CotizacionesService,
    ReplaceDate,
    ReplaceDecimal,
    ReportesService,
    SidenavService,
    SnackbarService,
    SpinnerngxService,
    TablasService,
    TooltipListPipe,
    UsuariosService,
    PAService,
    TPService,
    TDService,

    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    { provide: MatPaginatorIntl, useClass: MatPaginatorIntlCro },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerngxService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true,
    } 

  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
